import { useState, useEffect } from 'react';
import axios from 'axios';
import { Dropdown } from 'semantic-ui-react';

const OrganisationDropdown = ({
  value,
  onChange,
  placeholder = 'Select organisation…',
  className,
}) => {
  const [organisations, setOrganisations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get('/org/organisations', { params: { orderBy: 'name' } })
      .then((resp) => setOrganisations(resp.data))
      .catch(() => setOrganisations([]))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (event, { value: selectedId }) => {
    const organisation = organisations.find((o) => String(o.id) === selectedId);
    onChange(organisation || null);
  };

  return (
    <Dropdown
      placeholder={placeholder}
      fluid
      search
      selection
      clearable
      loading={loading}
      value={value ? String(value.id) : ''}
      options={organisations.map((o) => ({
        key: o.id,
        value: String(o.id),
        text: o.name,
      }))}
      onChange={handleChange}
      className={className}
    />
  );
};

export default OrganisationDropdown;
